import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const reveal = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.75, ease: EASE },
};

export default function SectionHead({ eyebrow, title, body, testid }) {
  return (
    <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
      <motion.div {...reveal} className="lg:col-span-7">
        <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-orange-400">
          <span className="h-px w-8 bg-orange-400" />
          {eyebrow}
        </p>
        <h2
          data-testid={testid}
          className="mt-5 font-display text-4xl font-bold tracking-tighter text-slate-50 sm:text-5xl lg:text-6xl"
        >
          {title}
        </h2>
      </motion.div>
      {body && (
        <motion.p {...reveal} transition={{ ...reveal.transition, delay: 0.12 }} className="max-w-md text-base leading-relaxed text-slate-400 lg:col-span-5 lg:justify-self-end">
          {body}
        </motion.p>
      )}
    </div>
  );
}
